import { render, staticRenderFns } from "./Usergroupmgr.vue?vue&type=template&id=e47f4a8c&scoped=true&"
import script from "./Usergroupmgr.vue?vue&type=script&lang=js&"
export * from "./Usergroupmgr.vue?vue&type=script&lang=js&"
import style0 from "./Usergroupmgr.vue?vue&type=style&index=0&id=e47f4a8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47f4a8c",
  null
  
)

export default component.exports